<template>
  <footer class="footer">
    <div class="footer-main">
      <div class="page-container" style="display: flex;flex-direction: row;justify-content: space-between;">
        <div class="footer-logo">
          <div style="flex: 1;">
            <img src="@/assets/images/home/logo.png" alt="沃雷顿自行车" class="logo-img"></img>
          </div>
          <div class="footer-nav">
            <router-link to="/legal/privacy">隐私政策</router-link>
            <router-link to="/legal/terms">服务条款</router-link>
            <router-link to="/sitemap">网站地图</router-link>
            <router-link to="/touch">联系我们</router-link>
          </div>
          <div class="copyright" style="padding-bottom: 5px;">
            <p>© {{ currentYear }} 惠州市喜德盛自行车有限公司 版权所有</p>
            <a href="https://beian.miit.gov.cn"  target="blank">粤ICP备2025474457号-1</a>
          </div>
        </div>


        <div class="footer-columns">
          <div class="footer-column" v-for="cate in categorys">
            <h3>{{ cate.name || '-' }}</h3>
            <ul class="footer-links">
              <li v-for="child in cate.children"><router-link :to="`/products/${child.id}`">{{ child.name || '-'
                  }}</router-link></li>
              <li></li>
            </ul>
          </div>

          <div class="footer-column">
            <h3>服务支持</h3>
            <ul class="footer-links">
              <li><router-link to="/legal/aftermarket">售后服务</router-link></li>
              <li><router-link to="/faq">常见问题</router-link></li>
            </ul>
          </div>

          <div class="footer-column">
            <h3>关于VORUAD</h3>
            <ul class="footer-links">
              <li><router-link to="/news">新闻资讯</router-link></li>
              <li><router-link to="/recruits">招聘岗位</router-link></li>
              <li><router-link to="/about">关于我们</router-link></li>
            </ul>
          </div>

        </div>
      </div>
    </div>

    <!-- 手机底部 -->
    <div class="mobile-footer">
      <div class="page-container" style="display: flex;flex-direction: column;">

        <div class="footer-columns">
          <div class="footer-column" v-for="cate in categorys">
            <h3>{{ cate.name || '-' }}</h3>
            <ul class="footer-links">
              <li v-for="child in cate.children"><router-link :to="`/products/${child.id}`">{{ child.name || '-'
                  }}</router-link></li>
              <li></li>
            </ul>
          </div>

          <div class="footer-column">
            <h3>服务支持</h3>
            <ul class="footer-links">
              <li><router-link to="/legal/aftermarket">售后服务</router-link></li>
              <li><router-link to="/faq">常见问题</router-link></li>
              <li></li>
            </ul>
          </div>

          <div class="footer-column">
            <h3>关于VORUAD</h3>
            <ul class="footer-links">
              <li><router-link to="/news">新闻资讯</router-link></li>
              <li><router-link to="/recruits">招聘岗位</router-link></li>
              <li><router-link to="/about">关于我们</router-link></li>
              <li></li>
            </ul>
          </div>

        </div>
        <div class="footer-logo">
          <img src="@/assets/images/home/logo.png" alt="沃雷顿自行车" class="logo-img">
          <div class="footer-nav">
            <router-link to="/legal/privacy">隐私政策</router-link>
            <router-link to="/legal/terms">服务条款</router-link>
            <router-link to="/sitemap">网站地图</router-link>
            <router-link to="/touch">联系我们</router-link>
          </div>
          <div class="copyright" style="padding-bottom: 5px;">
            <p>© {{ currentYear }} 惠州市喜德盛自行车有限公司 版权所有</p>
            <a href="https://beian.miit.gov.cn"  target="blank">粤ICP备2025474457号-1</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { getCategoryAll } from '@/api/product';

export default {
  name: 'AppFooter',
  setup() {
    const currentYear = computed(() => {
      return new Date().getFullYear();
    });

    const currentTime = ref('');
    const categorys = ref([]);
    const isLoading = ref(false);

    const updateCurrentTime = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');

      currentTime.value = `${year}-${month}-${day} ${hours}:${minutes}`;
    };

    // 获取分类
    const fetchCates = async () => {
      isLoading.value = true;
      try {
        const res = await getCategoryAll();
        if (res && res.data) {
          categorys.value = res.data?.map(item => {
            return {
              id: item.id,
              name: item.name,
              children: item?.children.map(c => { return { id: c.id, name: c.name } })
            }
          })
          //console.log(JSON.stringify(categorys.value));
        }

      } catch (error) {
        console.error('获取失败:', error);
        categorys.value = [];
      } finally {
        isLoading.value = false;
      }
    };


    onMounted(() => {
      fetchCates();
      updateCurrentTime();
      // 更新时间，每分钟更新一次
      setInterval(updateCurrentTime, 60000);
    });

    return {
      currentYear,
      currentTime,
      isLoading,
      categorys
    };
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: #000000;
  color: #f5f5f5;
  height: auto;

  .footer-main {
    background: url('@/assets/images/home/footer.png');
    background-size: cover;
    background-position: center center;
    /* 背景图填充容器 */
    // background-position: 0px 0px;
    /* 背景图居中显示 */
    background-repeat: no-repeat;
    padding: 60px 0 20px 0px;
    //height: 350px;


    .copyright {
      margin-top: 20px;

      p {
        margin: 0;
        font-size: 14px;
        opacity: 0.8;

        &:first-child {
          margin-bottom: 5px;
        }

        span {
          color: #10DD1E;
        }
      }
    }

    .footer-logo {
      display: flex;
      flex-direction: column;

      align-items: left;

      .logo-img {
        width: 350px;
        height: 60px;
        margin-right: 15px;
      }

      .company-info {
        margin-top: 20px;

        h2 {
          font-size: 20px;
          color: #163C7D;
          margin: 0 0 5px;
        }

        p {
          font-size: 14px;
          color: #666;
          margin: 0;
        }
      }
    }

    .footer-nav {
      display: flex;
      gap: 20px;

      a {
        color: #fff;
        opacity: 0.8;
        text-decoration: none;
        font-size: 14px;

        &:hover {
          opacity: 1;
          text-decoration: underline;
        }
      }
    }

    .footer-columns {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 30px;

      @media (max-width: 1200px) {
        grid-template-columns: repeat(4, 1fr);
      }

      @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 576px) {
        grid-template-columns: 1fr;
      }
    }

    .footer-column {
      h3 {
        font-size: 18px;
        color: #FFF;
        margin-bottom: 20px;
        font-weight: 500;
        position: relative;
        padding-bottom: 12px;

        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 40px;
          height: 2px;
          background-color: #10DD1E;
        }
      }

      .footer-links {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          margin-bottom: 12px;

          a {
            color: #999;
            text-decoration: none;
            font-size: 14px;
            transition: all 0.3s;
            position: relative;
            padding-left: 15px;

            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 8px;
              width: 5px;
              height: 5px;
              border-radius: 50%;
              background-color: #ccc;
            }

            &:hover {
              color: #10DD1E;
              padding-left: 18px;

              &::before {
                background-color: #10DD1E;
              }
            }
          }
        }
      }


    }
  }

  .mobile-footer {
    display: none;
    background-color: #000000;
    /* 背景图填充容器 */
    // background-position: 0px 0px;
    /* 背景图居中显示 */
    background-repeat: no-repeat;
    padding: 60px 0 0px;


    .copyright {
      margin-top: 20px;
      text-align: center;

      p {
        margin: 0;
        font-size: 14px;
        opacity: 0.8;

        &:first-child {
          margin-bottom: 5px;
        }

        span {
          color: #10DD1E;
        }
      }
    }

    .footer-logo {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;

      .logo-img {
        width: 350px;
        height: 60px;
      }

      .company-info {
        margin-top: 20px;

        h2 {
          font-size: 20px;
          color: #163C7D;
          margin: 0 0 5px;
        }

        p {
          font-size: 14px;
          color: #666;
          margin: 0;
        }
      }
    }

    .footer-nav {
      display: flex;
      gap: 20px;
      margin-top: 10px;

      a {
        color: #fff;
        opacity: 0.8;
        text-decoration: none;
        font-size: 14px;

        &:hover {
          opacity: 1;
          text-decoration: underline;
        }
      }
    }

    .footer-columns {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      margin-bottom: 40px;
      padding: 0 20px;
    }

    .footer-column {
      h3 {
        font-size: 18px;
        color: #FFF;
        margin-bottom: 20px;
        font-weight: 500;
        position: relative;
        padding-bottom: 12px;

        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 40px;
          height: 2px;
          background-color: #10DD1E;
        }
      }

      .footer-links {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        gap: 20px;

        li {
          margin-bottom: 12px;

          &:last-child {
            clear: left;
          }

          a {
            color: #999;
            text-decoration: none;
            font-size: 14px;
            transition: all 0.3s;
            position: relative;
            padding-left: 15px;

            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 8px;
              width: 5px;
              height: 5px;
              border-radius: 50%;
              background-color: #ccc;
            }

            &:hover {
              color: #10DD1E;
              padding-left: 18px;

              &::before {
                background-color: #10DD1E;
              }
            }
          }
        }
      }


    }
  }
}

// 响应式调整
@media (max-width: 576px) {
  .footer {

    .footer-main {
      display: none;
    }

    .mobile-footer {
      display: block;
    }
  }
}
</style>